export const SITE = {
  name: "HR Progress Coaching & Consulting",
  tagline: "組織行動論で、人と組織の実行力を高める。",
  description: "組織行動論をベースにした企業研修・コンサルティング。リーダーシップ・AI人材育成・組織変革を支援します。",
  email: "contact@hr-progress.com",
  url: "https://hr-progress.com",
};

export const NAV_LINKS = [
  { label: "ホーム", path: "/" },
  { label: "サービス", path: "/services" },
  { label: "実績・事例", path: "/cases" },
  { label: "コラム", path: "/blog" },
  { label: "FAQ", path: "/faq" },
  { label: "プロフィール", path: "/about" },
  { label: "お問い合わせ", path: "/contact" },
];

export const STATS = [
  { value: "MBA", label: "英国国立ウェールズ大学大学院取得", mono: true },
  { value: "10+", label: "年以上の企業研修・組織開発経験", mono: true },
  { value: "1,000+", label: "企業研修・受講者実績", mono: true },
];

export const SERVICES = [
  {
    id: "leadership",
    icon: "award",
    title: "リーダーシップ研修",
    subtitle: "法人・チーム向け ／ 主力プログラム",
    description:
      "組織行動論をベースに、リーダーとしての思考力と実行力を高める実践的な研修プログラム。心理的安全性の構築やフィードバック文化の醸成など、現場で即実践できるリーダー行動の変容を重視した設計です。",
    details: [
      "組織行動論に基づくリーダーシップスタイル診断",
      "心理的安全性・フィードバック文化の構築",
      "ケーススタディ・ロールプレイ形式のワークショップ",
      "3時間〜2日間の構成に対応（オンライン・対面）",
    ],
    target: "管理職・チームリーダー・次世代リーダー候補",
  },
  {
    id: "organization",
    icon: "users",
    title: "組織実行力向上研修",
    subtitle: "法人・経営層向け ／ 主力プログラム",
    description:
      "まず個人の強みにフォーカスし、チーム・組織の強みを特定。それらをビジネス成果にどう活かすかを設計する独自アプローチで、組織全体の実行力を高めます。大手製造業・IT企業・大手百貨店など幅広い業種での実績あり。",
    details: [
      "個人の強み診断とチームへの貢献スタイルの特定",
      "組織の強みのマッピングとビジネス活用設計",
      "強みを起点にした業務改善プロセスの体系化",
      "成果につながる行動計画の立案・実践ワーク",
    ],
    target: "経営者・人事担当者・組織変革リーダー",
  },
  {
    id: "ai-business",
    icon: "cpu",
    title: "AI×ビジネス人材育成",
    subtitle: "IT・ビジネス向け",
    description:
      "生成AI・Copilotなどのツール活用スキルと、ビジネス実務を掛け合わせた実践的な研修。AI時代に活躍できる人材を、組織行動論の視点から育成します。",
    details: [
      "生成AI・Microsoft Copilot活用の実務スキル習得",
      "ITセールスエンジニア向けカリキュラム（SPIN法・FABE法統合）",
      "技術専門性をビジネス提案力に変換するトレーニング",
      "AI時代の組織行動と人材育成プロセスの設計",
    ],
    target: "IT企業・セールスエンジニア・DX推進担当者",
  },
  {
    id: "coaching",
    icon: "user",
    title: "パフォーマンスコーチング",
    subtitle: "個人・管理職向け",
    description:
      "組織行動論の知見を活かした1on1コーチング。自分固有の強みと行動パターンを深く理解し、それをリーダーシップや日常業務にどう活かすかを継続的に支援します。",
    details: [
      "強み資質診断と自己理解の深化セッション",
      "強みを活かした目標設定・行動計画の策定",
      "気づきを促す問いを中心とした継続コーチング",
      "オンライン・対面どちらも対応",
    ],
    target: "管理職・リーダー・強みを活かした成長を目指す方",
  },
];

export const PROFILE = {
  name: "Manabu Yonehana",
  title: "HR Progress Coaching & Consulting 代表",
  subtitle: "企業研修講師・組織開発コンサルタント / MBA",
  philosophy: "人の強みにフォーカスし、組織の実行力を高めること。",
  bio: [
    "英国国立ウェールズ大学大学院にてMBAを取得。現在は製薬業界でマーケティングマネージャーとして活躍する傍ら、HR Progress Coaching & Consultingを主宰し、組織行動論をベースにした企業研修・組織開発コンサルティングを提供しています。",
    "リーダーシップ開発・組織実行力向上・AI×ビジネス人材育成を専門とし、大手企業から中小企業まで幅広い研修実績を持ちます。「現場で使えるフレームワーク」と「行動変容を促す問いの設計」を重視したプログラムが特徴です。",
    "NewsPicks認定コメンテーター（ヘルスケア・AI・ビジネス・教育分野）として、最新の業界動向も積極的に発信中。",
  ],
  credentials: [
    { label: "MBA", detail: "英国国立ウェールズ大学大学院" },
    { label: "専門", detail: "組織行動論・リーダーシップ・AI×ビジネス" },
    { label: "NewsPicks", detail: "認定コメンテーター" },
    { label: "対応形式", detail: "オンライン・対面" },
  ],
};

export const TESTIMONIALS = [
  {
    text: "研修を通じて自分の強みが明確になり、チームへの関わり方が大きく変わりました。実務に直結した内容で、すぐに実践できました。",
    author: "大手小売業 部長",
    company: "管理職研修受講者",
  },
  {
    text: "AIツールを活用した業務改善のアプローチが具体的で参考になりました。現場にすぐ持ち帰れる内容の濃さが素晴らしかったです。",
    author: "IT企業 マネージャー",
    company: "AI×ビジネス研修受講者",
  },
  {
    text: "コーチングを通じて、自分が何を大切にしているかが見えてきました。意思決定のスピードと自信が格段に上がりました。",
    author: "外資系企業 リーダー",
    company: "パフォーマンスコーチング受講者",
  },
];

export const CASES = [
  {
    id: "manufacturing",
    industry: "大手製造業",
    service: "リーダーシップ研修",
    scale: "管理職層 約30名",
    tag: "リーダーシップ研修",
    challenge: "部門横断のチームマネジメントに課題を抱える管理職が多く、メンバーのモチベーション低下や部門間の連携不足が経営課題となっていた。",
    approach: "組織行動論に基づくリーダーシップスタイル診断を実施。各自の強みとコミュニケーションスタイルを可視化し、チームへの関わり方を再設計するワークショップを2日間で実施。",
    result: "研修後3ヶ月で部門間の定例連携が自発的に開始。受講者の9割が「リーダーとしての行動が変わった」と回答。",
  },
  {
    id: "it",
    industry: "IT企業",
    service: "組織実行力向上研修",
    scale: "セールスエンジニア・営業職 約25名",
    tag: "組織実行力向上",
    challenge: "技術力の高いセールスエンジニアが多いが、個人プレーが目立ちチームとしての組織力が発揮されていなかった。個人の強みがチーム・組織に活かされていない状態だった。",
    approach: "個人の強み診断から始め、チーム内での貢献スタイルを可視化。各自の強みをどう組み合わせれば組織として最大の成果が出るかを設計するワークショップを実施。",
    result: "チーム内の相互理解が深まり、自然な役割分担と連携が生まれた。プロジェクトの対応速度と顧客満足度が向上。",
  },
  {
    id: "retail",
    industry: "大手百貨店",
    service: "AI×業務効率化研修",
    scale: "全社員対象 計200名",
    tag: "AI×業務効率化",
    challenge: "生成AIやCopilotなどのツールへの関心はあるものの、現場での活用が進まず、業務効率化が停滞していた。デジタルリテラシーの底上げが急務だった。",
    approach: "生成AI・Microsoft Copilotの実務活用スキルを習得するカリキュラムを設計。職種別のユースケースを盛り込み、全200名を対象に複数回に分けて実施。",
    result: "受講後、日常業務へのAIツール活用率が大幅に向上。資料作成・メール対応・情報整理などの業務時間が平均30%以上短縮。",
  },
];

export const FAQS = [
  {
    q: "料金はどのくらいですか？",
    a: "研修の内容・規模・時間によって異なります。半日研修（3時間）は15万円〜、1日研修は25万円〜が目安です。コーチングは月2回セッションで3万円〜です。まずはお気軽にご相談ください。",
    category: "料金・費用",
  },
  {
    q: "何名から研修を依頼できますか？",
    a: "5名から対応可能です。少人数の管理職研修（5〜10名）から、全社研修（50名以上）まで規模に合わせて設計します。",
    category: "研修について",
  },
  {
    q: "オンラインでも対応していますか？",
    a: "はい、オンライン・対面どちらも対応しています。ZoomやTeamsを使ったオンライン研修も、対面と同等の品質で実施できます。",
    category: "実施形式",
  },
  {
    q: "自社の課題に合わせてカスタマイズできますか？",
    a: "はい、すべてのプログラムはカスタマイズ対応しています。事前のヒアリングをもとに、貴社の課題・文化・参加者に合わせたプログラムを設計します。",
    category: "研修について",
  },
  {
    q: "研修後のフォローはありますか？",
    a: "オプションで研修後の振り返りセッションやフォローアップコーチングにも対応しています。行動変容を継続的に支援したい場合はご相談ください。",
    category: "研修について",
  },
  {
    q: "初回相談は無料ですか？",
    a: "はい、初回のご相談（30〜45分）は無料で対応しています。貴社の課題やご要望をお聞きし、最適なプログラムをご提案します。",
    category: "相談・契約",
  },
  {
    q: "コーチングは何回から始められますか？",
    a: "まずは単発の体験セッション（60分）から始めることができます。継続的なコーチングは月2回セッションを基本としています。",
    category: "コーチングについて",
  },
  {
    q: "支払い方法は？",
    a: "銀行振込に対応しています。法人のお客様は請求書払いも可能です。詳細はお問い合わせの際にご確認ください。",
    category: "料金・費用",
  },
];

export const BLOG_POSTS = [
  {
    id: "organizational-behavior-basics",
    title: "組織行動論とは何か？ビジネス現場での活かし方",
    category: "組織行動論",
    date: "2026-05-20",
    excerpt: "組織行動論は、人・チーム・組織がどのように機能するかを科学的に分析する学問。感覚論ではなく、再現性のある組織変革を実現するための理論的基盤を解説します。",
    readTime: "6分",
  },
  {
    id: "leadership-strengths",
    title: "強みを起点にしたリーダーシップ：弱みの克服より強みの活用が効果的な理由",
    category: "リーダーシップ",
    date: "2026-05-10",
    excerpt: "ポジティブ心理学と組織行動論の知見が示すのは「弱みを直すより強みを伸ばす」ほうが組織パフォーマンスは上がるという事実。その背景とリーダーへの実践的示唆を解説。",
    readTime: "6分",
  },
  {
    id: "ai-human-skills",
    title: "AI時代に求められる人材とは？組織行動論の視点から考える",
    category: "AI×ビジネス",
    date: "2026-04-28",
    excerpt: "生成AIが普及する時代に、人間に求められるスキルは何か。「問いを立てる力」「関係性を構築する力」の重要性を組織行動論の視点から考察します。",
    readTime: "5分",
  },
  {
    id: "psychological-safety",
    title: "心理的安全性はなぜ重要か？Googleの研究から学ぶ高パフォーマンスチームの条件",
    category: "組織行動論",
    date: "2026-04-15",
    excerpt: "Googleの大規模研究「Project Aristotle」が明らかにした高パフォーマンスチームの条件。心理的安全性とは何か、どう醸成するかを実践的に解説します。",
    readTime: "7分",
  },
  {
    id: "feedback-culture",
    title: "フィードバック文化の作り方：言いやすい職場をデザインする",
    category: "リーダーシップ",
    date: "2026-04-01",
    excerpt: "日本企業で最も難しいとされるフィードバック。「言いたくても言えない」文化をどう変えるか。組織行動論に基づく具体的なアプローチを紹介します。",
    readTime: "6分",
  },
  {
    id: "spin-fabe-sales",
    title: "技術者が営業力を身につける方法：SPIN法とFABE法の実践",
    category: "AI×ビジネス",
    date: "2026-03-20",
    excerpt: "「技術は分かるが提案が弱い」という課題を持つエンジニアやSEのために、SPIN法とFABE法を使った顧客への価値伝達方法を解説します。",
    readTime: "6分",
  },
  {
    id: "coaching-vs-teaching",
    title: "コーチングとティーチングの使い分け：リーダーが知っておくべき関わり方の原則",
    category: "リーダーシップ",
    date: "2026-06-08",
    excerpt: "「教えるべきか、問うべきか」——この判断を誤ると、いくら時間をかけても部下は育たない。コーチングとティーチングは対立する手法ではなく、使い分けるべき補完的なツール。その原則と判断基準を解説します。",
    readTime: "4分",
  },
  {
    id: "emotional-intelligence-leadership",
    title: "感情知性（EQ）とリーダーシップ：なぜIQより重要とされるのか",
    category: "リーダーシップ",
    date: "2026-06-16",
    excerpt: "「頭が良くて優秀なのになぜかチームがついてこない」——この悩みの背景に、感情知性（EQ）の欠如があるケースは少なくありません。ダニエル・ゴールマンの研究が示したのは、リーダーの成果の約90%がIQではなくEQによって決まるという衝撃的な事実。その構造と実践的な高め方を解説します。",
    readTime: "4分",
  },
  {
    id: "intrinsic-motivation-leadership",
    title: "部下が自ら動く組織をつくる：内発的動機付けの科学とリーダーの役割",
    category: "組織行動論",
    date: "2026-06-23",
    excerpt: "「言われたことはやるけど、それ以上は動かない」——この悩みを抱えるリーダーは少なくありません。問題の根本は「動機付けの設計」にあります。外からの報酬や罰則に頼るマネジメントには限界があり、人が本来持つ「内側からの動力」を引き出す仕組みこそが、持続的な組織パフォーマンスを生み出します。",
    readTime: "4分",
  },
];
